import { UserSession } from '@/infrastructure';
import { BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';
import { LordBusinessClient } from '@studyportals/sp-lord-business-interface';

import { RequestSender } from './';
import { OptimizedAuthorizedS3TransferMedium } from './optimized-authorized-s3-transfer-medium';
import { RegionAwareAuthorizedS3Adapter } from './region-aware-authorized-s3-adapter';

const lordBusinessQueryUrl = webpackDefinitions.VUE_APP_LORD_BUSINESS_QUERY_URL;
const lordBusinessCommandUrl = webpackDefinitions.VUE_APP_LORD_BUSINESS_COMMAND_URL;
const bucketName = webpackDefinitions.VUE_APP_PRESENTATION_ENROLMENTS_S3_BUCKET;
const bucketRegion = webpackDefinitions.VUE_APP_PRESENTATION_ENROLMENTS_S3_BUCKET_REGION;
const bucketContentAcceleration = webpackDefinitions.VUE_APP_PRESENTATION_ENROLMENTS_S3_BUCKET_CONTENT_ACCELERATION === 'ENABLED';


const lordBusiness = new LordBusinessClient(
	new OptimizedAuthorizedS3TransferMedium(
		new RegionAwareAuthorizedS3Adapter(UserSession.credentialsLifetimeManager, bucketRegion, bucketContentAcceleration, bucketName)
	),
	new BaseSuperAgentRequestFactory(),
	RequestSender,
	lordBusinessQueryUrl,
	lordBusinessCommandUrl
);

export default lordBusiness;
